//////////////////////
// Global Variables //
//////////////////////
var $ = jQuery;


///////////////////////////
// Document Ready Events //
///////////////////////////
$(document).ready(function() {

  // inside label position helper
  $('form#gform_1 li.gfield#field_1_1 input, form#gform_5 li.gfield#field_5_1 input').on('click keypress focus blur', function() {
    var first_ = $(this).val().indexOf('_');
    $(this).get(0).setSelectionRange(first_,first_);
  });

  // inside label position helper
  $('.gfield.inside_label input').each(function() {
    if ($(this).val()) {
      $(this).parent().parent().addClass('focus_filled');
    }
  }).focus(function() {
    $(this).parent().parent().addClass('focus_filled');
  }).blur(function() {
    if (!$(this).val()) {
      $(this).parent().parent().removeClass('focus_filled');
    }
  });

  // date picker width helper 
  $('.gfield input.datepicker').on('focus blur click',function() {
    $('#ui-datepicker-div').width($(this).outerWidth()-2);
  }).on('keydown',function() {
    $('#ui-datepicker-div').css('display', 'none');
  });

  if ($('body').hasClass('compare-providers')) {
    // compare providers adjust fieldset width
    var compare_form_width = $('.gform_body').outerWidth();
    $('fieldset.gform_fieldset').outerWidth(compare_form_width);
  }

  // compare provider stop enter key
  $('body.compare-builder form#gform_5').on('keypress', function(event) {
    return event.keyCode != 13;
  });

  // compare provider validation of fields
  function validate_user_details() {
    if ($('form#gform_5 li.gfield.postal_code input').hasClass('valid') && 
        $('form#gform_5 li.gfield.user_name input').hasClass('valid') && 
        $('form#gform_5 li.gfield.user_email input').hasClass('valid')) {
          // $('form#gform_5 #personal_info_next').html('Next').parent().removeClass('gfield_error');
          $('.section_details button.button').html('Show me the results').parent().removeClass('gfield_error');
    }
  }

  // compare providers validation: postal code
  $('form#gform_5 li.gfield.postal_code input').on('load change input keyup focus blur', function() {
    if (/^[0-9]{5}$/.test($(this).val())) {
      // console.log('zip populated');
      $(this).addClass('valid').closest('.gfield').removeClass('gfield_error');
    }
    else {
      $(this).removeClass('valid');
    }
    validate_user_details();
  });

  // compare providers validation: user name
  $('form#gform_5 li.gfield.user_name input').on('load change input keyup focus blur', function() {
    // if name has first name with 2 characters or more, and then 1 space, and then two characters or more for last name
    if (/^[a-zA-Z\u00F0-\u02AF]{2,}[\W]{1}[a-zA-Z\u00F0-\u02AF']{2,}.*/.test($(this).val())) {
    // if entry has two characters or more
    // if (/^[a-zA-Z\u00F0-\u02AF]{2,}.*/.test($(this).val())) {
      // console.log('username populated');
      $(this).addClass('valid').closest('.gfield').removeClass('gfield_error');
    } else {
      $(this).removeClass('valid');
    }
    validate_user_details();
  });

  // compare providers validation: user email
  $('form#gform_5 li.gfield.user_email input').on('load change input keyup focus blur', function() {
    if (/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test($(this).val())) {
      // console.log('email populated');
      $(this).addClass('valid').closest('.gfield').removeClass('gfield_error');
    } else {
      $(this).removeClass('valid');
    }
    validate_user_details();
  });

  // compare providers save and continue
  $('.section_arrest button.button').on('click', function(e) {

    e.preventDefault();
    $('form#gform_5 li.gfield.postal_code input, form#gform_5 li.gfield.user_name input, form#gform_5 li.gfield.user_email input').trigger('blur');

    $('.gform_body').addClass('details');
    $('.form-section-arrest').removeClass('active');
    $('.form-section-details').addClass('active');

    var stateObj = { compare_progress: "details" };
    history.pushState(stateObj, "step 2");

    setTimeout(function(){
      $("html,body").animate({scrollTop: '0px'}, 1000, 'swing');
    },1000);

  });

  // compare providers submit
  $('.section_details button.button').on('click', function() {

    $('form#gform_5 li.gfield.postal_code input, form#gform_5 li.gfield.user_name input, form#gform_5 li.gfield.user_email input').trigger('blur');

    if ($('form#gform_5 li.gfield.postal_code input').hasClass('valid') &&
        $('form#gform_5 li.gfield.user_name input').hasClass('valid') &&
        $('form#gform_5 li.gfield.user_email input').hasClass('valid')) {

      setTimeout(function() {
        document.forms["gform_5"].submit();
      }, 50);

    }
    else {

      if (!$('form#gform_5 li.gfield.postal_code input').hasClass('valid')) {
        $('form#gform_5 li.gfield.postal_code').addClass('gfield_error');
      }
      if (!$('form#gform_5 li.gfield.user_name input').hasClass('valid')) {
        $('form#gform_5 li.gfield.user_name').addClass('gfield_error');
      }
      if (!$('form#gform_5 li.gfield.user_email input').hasClass('valid')) {
        $('form#gform_5 li.gfield.user_email').addClass('gfield_error');
      }
      $(this).html('Fields Missing or Invalid').parent().addClass('gfield_error');

    }
    
    
  });

  // auto center results loader
  if ($('body').hasClass('compare-results')) {
    $('.loader-container').css({'height':($(window).height()-$('.loader-container').offset().top)*0.8+'px'});
  }

});


////////////////////////////////////
// Post-Binding Delegation Events //
////////////////////////////////////
// flyout details button
$(document).on('click','.flyout-button', function() {
  if ($(this).hasClass('active')) {
    $(this).blur().removeClass('active').next('.flyout-details').removeClass('active');
  }
  else {
    $(this).blur().addClass('active').next('.flyout-details').addClass('active');
  }
});


///////////////////////////
// Window History Events //
///////////////////////////
window.onpopstate = function(event) {
  // console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
  if (event.state === null) {
    $('.gform_body').removeClass('details');
    $('.form-section-arrest').addClass('active');
    $('.form-section-details').removeClass('active');
  }
};

////////////////////////////////
// Window Fully Loaded Events //
////////////////////////////////
$(window).on('load', function() {
  $('#gform_5 li.gfield').find('input').attr({'autocomplete':'off','autocorrect':'off','autocapitalize':'none','spellcheck':'false'});
});


//////////////////////////
// Window Resize Events //
//////////////////////////
$(window).on('resize DOMSubtreeModified', function() {

  if ($('body').hasClass('compare-providers')) {
    // compare providers adjust fieldset width
    var compare_form_width = $('.gform_body').outerWidth();
    $('fieldset.gform_fieldset').outerWidth(compare_form_width);
  }
  

  if ($('body').hasClass('compare-results')) {
    if ($(window).width() <= 940) {
      $('.flyout-button, .flyout-details').removeClass('active');
    }
    else {
      $('.flyout-button, .flyout-details').addClass('active');
    }
  }

});
